// Suivi de conversion — GA4 + Google Ads (gtag.js déjà chargé dans index.html)
//
// GA4 est actif (G-4YJZNCH145). Pour envoyer AUSSI la conversion directement à
// Google Ads, renseigne les send_to ci-dessous avec ton identifiant de conversion
// et le libellé fournis par Google Ads, au format "AW-XXXXXXXXX/AbC-dEfGhIjK".
// Tant qu'ils sont vides, seul l'événement GA4 est envoyé (importable dans Ads).
export const ADS_SEND_TO = {
  form: "AW-18353810501/vFqLCIjw4vYcEMXY469E", // Conversion "Demande de devis"
  phone: "",  // Conversion "Appel téléphonique" (optionnel — libellé requis)
};

const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

// Anti-doublon : une même soumission (référence unique) ne peut déclencher
// la conversion qu'une seule fois, même en cas de re-rendu, retour arrière
// ou rechargement (persisté via sessionStorage + garde mémoire).
const _fired = new Set();
const alreadyFired = (reference) => {
  if (!reference) return false;
  if (_fired.has(reference)) return true;
  _fired.add(reference);
  try {
    const key = "vd_conv_" + reference;
    if (window.sessionStorage.getItem(key)) return true;
    window.sessionStorage.setItem(key, "1");
  } catch (e) {
    /* sessionStorage indisponible : la garde mémoire suffit */
  }
  return false;
};

// Envoi réussi du formulaire de soumission -> conversion (une seule fois)
export const trackFormConversion = ({ reference, region, projectType } = {}) => {
  if (alreadyFired(reference)) return;
  // Événement GA4 recommandé pour un lead (importable dans Google Ads)
  gtag("event", "generate_lead", {
    currency: "CAD",
    value: 0,
    form_reference: reference || "",
    region: region || "",
    project_type: projectType || "",
  });
  // Conversion Google Ads directe (uniquement si le libellé est configuré).
  // transaction_id = dédoublonnage côté Google Ads pour la même soumission.
  if (ADS_SEND_TO.form) {
    gtag("event", "conversion", {
      send_to: ADS_SEND_TO.form,
      value: 1.0,
      currency: "CAD",
      transaction_id: reference || "",
    });
  }
};

// Vue de page virtuelle de l'écran de remerciement (SPA) — déclenche un rapport
// GA4 pour "/soumission/merci" avec l'identifiant unique de la soumission.
export const trackThankYou = (reference) => {
  const path = "/soumission/merci";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  gtag("event", "page_view", {
    page_title: "Merci — Soumission envoyée",
    page_location: origin + path,
    page_path: path,
    lead_reference: reference || "",
    transaction_id: reference || "",
  });
};

// Clic sur un numéro de téléphone (lien tel:)
export const trackPhoneClick = () => {
  gtag("event", "phone_call", { method: "tel_link" });
  if (ADS_SEND_TO.phone) {
    gtag("event", "conversion", { send_to: ADS_SEND_TO.phone });
  }
};

// Écoute globale des clics sur les liens téléphone du site entier.
let phoneBound = false;
export const initPhoneTracking = () => {
  if (phoneBound || typeof document === "undefined") return;
  phoneBound = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (a) trackPhoneClick();
    },
    true
  );
};
